module.exports = __webpack_public_path__ + "static/media/MarkPro-Bold.082e3cb1.woff";